import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from '@/shared/layout';
import { Button } from '@/components/ui';
import { useConstructionProgressLogs } from './hooks/useConstructionProgressLogs';
import { useCompany } from '@/modules/company/hooks/useCompany';
import { ProgressKPIBoard } from './components/ProgressKPIBoard';
import { ProgressToolbar } from './components/ProgressToolbar';
import { ProgressTable } from './components/ProgressTable';
import { AuthButton } from '@/core/permissions/AuthButton';

export default function ProgressListPage() {
  const navigate = useNavigate();
  const { company } = useCompany();
  const { 
    logs, 
    isLoading, 
    stats, 
    filters, 
    setFilters 
  } = useConstructionProgressLogs(company?.id || '');

  return (
    <PageLayout
      title="Nhật ký tiến độ"
      description="Quản lý báo cáo tiến độ thi công, sản lượng và hình ảnh thực tế từ hiện trường"
      breadcrumbs={[{ label: 'Thi công' }, { label: 'Tiến độ' }]}
      actions={
        <div className="flex gap-2">
          <Button variant="outline" icon="ri-download-line">Xuất báo cáo</Button>
          <AuthButton module="construction" action="create" variant="primary" icon="ri-add-line" onClick={() => navigate('/construction/progress/create')}>
            Ghi nhận tiến độ
          </AuthButton>
        </div>
      }
    >
      <ProgressKPIBoard stats={stats} isLoading={isLoading} />
      
      <ProgressToolbar 
        filters={filters} 
        onFilterChange={setFilters} 
        onAdd={() => navigate('/construction/progress/create')}
      />

      <ProgressTable 
        data={logs} 
        isLoading={isLoading} 
        onViewDetail={(id) => navigate(`/construction/progress/detail/${id}`)}
      />
    </PageLayout>
  );
}
